import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import './GenreSelectCard.scss'
import { GENRE } from 'services/types';

interface IGenreSelectCardProps {
  genre: GENRE;
  isSelected?: boolean;
  onClick?: (genre: GENRE) => void;
  disabled?: boolean;
}

const GenreSelectCard = ({
  genre,
  isSelected,
  onClick,
  disabled,
}: IGenreSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('genre-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(genre)}
    >
      <div className="genre-select-card-header">
        <div className="genre-select-card-header-name">
          {t(`genre.${GENRE[genre]}.name`)}
        </div>
        <div className="genre-select-card-header-description">
          {t(`genre.${GENRE[genre]}.description`)}
        </div>
      </div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default GenreSelectCard;
